import { axiosRequest } from '@/util/axios-request'
// 获取子项目-付薪月份list
export const getPayMonthList = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/getPayMonthList',
    method: 'POST',
    data
  })

// 子项目列表list
export const payrollSubProjectList = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/list',
    method: 'GET',
    params: data
  })

// 子项目列表list_sort
export const sortSubProject = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/sortSubProject',
    method: 'POST',
    data
  })

// 项目添加&编辑
export const payrollProjectSave = data =>
  axiosRequest({
    url: '/web/payroll_project/save',
    method: 'POST',
    params: data
  })

// 项目列表
export const payrollProjectList = data =>
  axiosRequest({
    url: '/web/payroll_project/list',
    method: 'GET',
    params: data
  })

// 项目详情
export const payrollProjectDetail = data =>
  axiosRequest({
    url: '/web/payroll_project/read',
    method: 'GET',
    params: data
  })

// 子项目创建
export const payrollSubProjectCreate = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/create',
    method: 'POST',
    data
  })

// 获取当前正在进行中的任务数量Cout
export const getPendingTaskCount = data =>
  axiosRequest({
    url: '/web/background_task/getPendingTaskCount',
    method: 'GET',
    params: data
  })

// 获取完成任务list
export const getCompletedTaskList = data =>
  axiosRequest({
    url: '/web/background_task/getCompletedTaskList',
    method: 'GET',
    params: data
  })

// 获取进行任务list
export const getPendingTaskList = data =>
  axiosRequest({
    url: '/web/background_task/getPendingTaskList',
    method: 'GET',
    params: data
  })

// 同步计薪方案 到 子项目
export const schemeToSubProject = data =>
  axiosRequest({
    url: '/web/payroll_rule/syncSchemeRuleToSubProject',
    method: 'POST',
    data
  })

// 计薪方案-获取list-by settlement_type
export const getListByType = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_scheme/getListByType',
    method: 'get',
    params: data
  })

// 工资计算-获取scheme 全部设置
export const getSettingInfo = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_scheme/getSettingInfo',
    method: 'get',
    params: data
  })

// 子项目删除
export const payrollSubProjectDelete = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/remove',
    method: 'get',
    params: data
  })

// 子项目删除
export const getAllSubProjectListGroupByPayMonth = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/getAllSubProjectListGroupByPayMonth',
    method: 'POST',
    data
  })

// 子项目归档
export const payrollSubProjectOnFile = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/onFile',
    method: 'POST',
    params: data
  })

// 子项目取消归档
export const payrollSubProjectCancelOnFile = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/cancelOnFile',
    method: 'POST',
    params: data
  })

// 子项目 取消归档 提示
export const getCancelOnFileNotice = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/getCancelOnFileNotice',
    method: 'POST',
    params: data
  })

// 子项目 归档 提示
export const getOnFileNotice = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/getOnFileNotice',
    method: 'POST',
    params: data
  })

// 子项目基本信息
export const payrollSubProjectInfo = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/viewBaseInfo',
    method: 'GET',
    params: data
  })

// 子项目基本信息
export const savePayrollSubProject = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/save',
    method: 'POST',
    data
  })

// 子项目-list -header-coloums
export const getListHeaderColumns = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/getListHeaderColumns',
    method: 'POST',
    data
  })

// 子项目员工列表
export const payrollSubStaffList = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/list',
    method: 'GET',
    params: data
  })

// 子项目员工编辑
export const payrollSubStaffSave = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/save',
    method: 'POST',
    data
  })

// 子项目员工删除
export const payrollSubStaffDelete = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/remove',
    method: 'POST',
    data
  })

// 子项目添加员工
export const payrollSubStaffAdd = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/add',
    method: 'POST',
    data
  })

// 同步staff_item 到 sub project staff_item
export const syncStaffItem = data =>
  axiosRequest({
    url: '/web/payroll_rule/syncStaffItem',
    method: 'POST',
    data
  })

// 子项目-清空所有员工的税
export const clearSalaryMonthTax = data =>
  axiosRequest({
    url: '/web/payroll_rule//clearSalaryMonthTax',
    method: 'post',
    params: data
  })

// 子项目-批量修改税-模版
export const exportTaxExcel = data =>
  axiosRequest({
    url: '/web/payroll_rule/export_tax_excel',
    method: 'get',
    params: data
  })

// 子项目员工薪资信息详情
export const payrollSubStaffDetail = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/read',
    method: 'GET',
    params: data
  })
// 子项目员工薪资信息保存
export const payrollSubStaffDetailSave = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/save',
    method: 'POST',
    data
  })

// 银行列表
export const payrollBanks = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/bankItem',
    method: 'GET',
    params: data
  })

// 员工薪资列表
export const payrollStaffList = data =>
  axiosRequest({
    url: '/web/payroll_staff/list',
    method: 'GET',
    params: data
  })

// 员工调薪记录
export const payrollStaffHistory = data =>
  axiosRequest({
    url: '/web/payroll_staff/changepaylist',
    method: 'GET',
    params: data
  })

// 员工调薪记录
export const payrollStaffInfo = data =>
  axiosRequest({
    url: '/web/payroll_staff/read',
    method: 'GET',
    params: data
  })

// 员工薪资信息保存
export const payrollStaffSave = data =>
  axiosRequest({
    url: '/web/payroll_staff/save',
    method: 'post',
    data
  })

// 导出员工薪资数据
export const payrollStaffExport = data =>
  axiosRequest({
    url: '/web/payroll_staff/exportPayInfoData',
    method: 'GET',
    params: data
  })

// 校验年度收入是否要归档
export const checkYearIncomeArchive = data =>
  axiosRequest({
    url: '/web/payroll_staff/checkYearIncomeArchive',
    method: 'POST',
    data
  })

// 归档年度累计值
export const saveYearIncomeArchive = data =>
  axiosRequest({
    url: '/web/payroll_staff/saveYearIncomeArchive',
    method: 'POST',
    data
  })

// 员工薪资信息导出模版
export const payrollStaffTpl = data =>
  axiosRequest({
    url: '/web/payroll_staff/downloadStaffPayInfoTpl',
    method: 'GET',
    params: data
  })

// 子项目员工薪资信息模板导出
export const downloadStaffPayInfoTpl = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/downloadStaffPayInfoTpl',
    method: 'GET',
    params: data
  })

// 同上
export const downloadStaffPayInfoTplNew = data =>
  axiosRequest({
    url: '/web/payroll_rule/export_staff_excel',
    method: 'GET',
    params: data
  })

// 子项目员工保存行数据
export const saveItemInfo = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/save_item',
    data
  })

// 计算工资
export const downloadPaySheet = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/downloadPaySheet',
    method: 'GET',
    params: data,
    timeout: null
  })

// 子项目-计算状态
export const getSubProjectCalculateState = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/getSubProjectCalculateState',
    data,
    timeout: null
  })

// 生成工资表
export const calculate = data =>
  axiosRequest({
    url: '/web/payroll_rule/calculate',
    data,
    timeout: null
  })

// 员工薪资信息导入
export const payrollStaffImport = data =>
  axiosRequest({
    url: '/web/payroll_staff/uploadStaffPayInfoFile',
    method: 'post',
    params: data
  })

// 子员工薪资信息模板
export const payrollSubStaffTpl = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/downloadStaffPayInfoTpl',
    method: 'post',
    params: data
  })

// 子员工薪资信息导入
export const payrollSubStaffImport = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/uploadStaffPayInfoData',
    method: 'post',
    data
  })
// 员工薪资信息列表
export const payrollStaffDetail = data =>
  axiosRequest({
    url: '/web/payroll_staff/read',
    method: 'GET',
    params: data
  })

// 员工薪资信息保存
export const payrollStaffDetailSave = data =>
  axiosRequest({
    url: '/web/payroll_staff/save',
    method: 'post',
    data
  })

// 子员工薪资信息模板
export const payrollKaoqinDownFn = data =>
  axiosRequest({
    url: '/web/payroll_rule/export_attendance_excel',
    method: 'get',
    params: data
  })

// 生成考勤数据
export const generateAttendance = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/generateAttendance',
    method: 'post',
    data
  })

// 自定义项
export const itemlist = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/itemlist',
    method: 'get',
    params: data
  })

// 创建自定义薪资项
export const createitem = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/createitem',
    method: 'post',
    data
  })

// update自定义薪资项
export const updateitem = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/updateitem',
    method: 'post',
    data
  })

// 合并生成工资表
export const downloadPaySheetCombined = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/downloadPaySheetCombined',
    data
  })

// 员工调薪read
export const readUpdateSalary = data =>
  axiosRequest({
    url: '/web/payroll_staff/readUpdateSalary',
    method: 'GET',
    params: data
  })

// 员工调薪save
export const saveUpdateSalary = data =>
  axiosRequest({
    url: '/web/payroll_staff/saveUpdateSalary',
    method: 'POST',
    data
  })

// 调薪历史log_ 修改接口
export const saveUpdateLDateLog = data =>
  axiosRequest({
    url: '/web/payroll_staff/resetStaffSalaryUpdateLDateLog',
    method: 'POST',
    data
  })

// 调薪原因type列表
export const updateSalaryReasonTypeList = data =>
  axiosRequest({
    url: '/web/payroll_staff/getUpdateSalaryReasonTypeList',
    method: 'GET',
    params: data
  })

// 员工调薪记录
export const getStaffUpdateSalaryDetailList = data =>
  axiosRequest({
    url: '/web/payroll_staff/getStaffUpdateSalaryDetailList',
    method: 'get',
    params: data
  })

// 批量调薪-list
export const getBatchUpdateSalaryList = data =>
  axiosRequest({
    url: '/web/payroll_staff/getBatchUpdateSalaryList',
    method: 'POST',
    data
  })

// 批量调薪-保存调薪数据
export const saveBatchUpdateSalaryData = data =>
  axiosRequest({
    url: '/web/payroll_staff/saveBatchUpdateSalaryData',
    method: 'POST',
    data
  })

// 调薪历史log
export const getLogList = data =>
  axiosRequest({
    url: '/web/payroll_staff/getStaffSalaryUpdateDateLogList',
    method: 'GET',
    params: data
  })

// 调薪历史log_ 新增调薪或者编辑调薪的时候
export const getSalaryNotice = data =>
  axiosRequest({
    url: '/web/payroll_staff/getUpdateSalaryNotice',
    method: 'GET',
    params: data
  })

// 调薪历史log_ 撤销
export const repealSalaryDate = data =>
  axiosRequest({
    url: '/web/payroll_staff/repealStaffSalaryUpdateLDate',
    method: 'POST',
    data
  })

// 调薪历史log_detail
export const getLogDetail = data =>
  axiosRequest({
    url: '/web/payroll_staff/getStaffSalaryUpdateDateLogDetail',
    method: 'GET',
    params: data
  })

// 批量调薪-下载员工excel 模版
export const downloadBatchUpdateSalaryTpl = data =>
  axiosRequest({
    url: '/web/payroll_staff/downloadBatchUpdateSalaryTpl',
    method: 'POST',
    data
  })

// 批量调薪-上传员工excel
export const uploadBatchUpdateSalaryData = data =>
  axiosRequest({
    url: '/web/payroll_staff/uploadBatchUpdateSalaryData',
    method: 'POST',
    data
  })

// 员工调薪详情_type
export const getStaffUpdateSalaryDetailType = data =>
  axiosRequest({
    url: '/web/payroll_staff/getStaffUpdateSalaryDetailType',
    method: 'post',
    data
  })
